export default function selectionKey(ids: number[]): string {
  return [...new Set(ids)].sort((a, b) => a - b).join();
}
